import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { fetchEmailQueue } from "../../lib/api";

export const EmailQueueNote = ({ token }) => {
  const [q, setQ] = useState(null);
  useEffect(() => {
    fetchEmailQueue(token).then(({ data }) => setQ(data)).catch(() => {});
  }, [token]);
  if (!q || (q.pending === 0 && q.failed === 0)) return null;
  return (
    <p data-testid="admin-email-queue-note" className="mt-4 flex items-center gap-2 text-sm text-[#6B4A1F]">
      <Clock className="h-4 w-4" />
      {q.pending} email{q.pending === 1 ? "" : "s"} waiting to retry (email rate limit){q.failed ? `, ${q.failed} failed` : ""}.
    </p>
  );
};
